import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/layout/index.vue'

Vue.use(Router)

/*
  redirect:                      if set to 'noredirect', no redirect action will be trigger when clicking the breadcrumb
  meta: {
    title: 'title'               the name showed in subMenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon showed in the sidebar
    breadcrumb: false            if false, the item will be hidden in breadcrumb (default is true)
    hidden: true                 if true, this route will not show in the sidebar (default is false)
  }
*/

export default new Router({
  // mode: 'history', // Enable this if you need.
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      component: () => import(/* webpackChunkName: "login" */ '@/views/login/index.vue'),
      meta: {
        title: 'etsme',
        hidden: true
      }
    },
    {
      path: '/404',
      component: () => import(/* webpackChunkName: "404" */ '@/views/404.vue'),
      meta: { hidden: true }
    },
    {
      path: '/',
      component: Layout,
      redirect: '/dashboard',
      children: [
        {
          path: 'dashboard',
          component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/index.vue'),
          meta: {
            title: 'Dashboard',
            icon: 'dashboard'
          }
        }
      ]
    },
    {
      path: '/recruit',
      component: Layout,
      redirect: '/recruit',
      meta: {
        title: '招聘',
        icon: 'table',
        roles: ['admin', 'editor'], // you can set roles in root nav
        alwaysShow: true // will always show the root menu
      },
      children: [
        {
          path: '/info',
          component: () => import(/* webpackChunkName: "dashboard" */ '@/views/table/job/index.vue'),
          meta: {
            title: '投档信息',
            roles: ['admin', 'editor']
          }
        },
        {
          path: '/campus-list',
          component: () => import(/* webpackChunkName: "dashboard" */ '@/views/table/job/campus/index.vue'),
          meta: {
            title: '校园招聘',
            roles: ['admin', 'editor']
          }
        },
        {
          path: '/social-list',
          component: () => import(/* webpackChunkName: "dashboard" */ '@/views/table/job/social/index.vue'),
          meta: {
            title: '社会招聘',
            roles: ['admin', 'editor']
          }
        }
      ]
    },
    {
      path: '/news',
      component: Layout,
      meta: {
        title: '新闻',
        icon: 'newspaper',
        roles: ['admin', 'editor'], // you can set roles in root nav
        alwaysShow: true // will always show the root menu
      },
      children: [
        {
          path: 'manage',
          component: () => import(/* webpackChunkName: "dashboard" */ '@/views/news/NewsManage.vue'),
          meta: {
            title: '新闻管理'
          }
        },
        {
          path: 'published',
          component: () => import(/* webpackChunkName: "dashboard" */ '@/views/news/NewsPublished.vue'),
          meta: {
            title: '已发布'
          }
        },
        {
          path: 'draft',
          component: () => import(/* webpackChunkName: "dashboard" */ '@/views/news/NewsDraft.vue'),
          meta: {
            title: '草稿箱'
          }
        },
        {
          path: 'recycleBin',
          component: () => import(/* webpackChunkName: "dashboard" */ '@/views/news/NewsRecycleBin.vue'),
          meta: {
            title: '回收站'
          }
        }
      ]
    },
    {
      path: '/monitor',
      component: Layout,
      meta: {
        title: '链接监控',
        icon: 'newspaper',
        roles: ['admin', 'editor'], // you can set roles in root nav
        alwaysShow: true // will always show the root menu
      },
      children: [
        {
          path: 'manage',
          component: () => import(/* webpackChunkName: "dashboard" */ '@/views/monitor/Manage.vue'),
          meta: {
            title: '跳转链接设置'
          }
        },
        {
          path: 'dataView',
          component: () => import(/* webpackChunkName: "dashboard" */ '@/views/monitor/ClickView.vue'),
          meta: {
            title: '数据查看'
          }
        }
      ]
    },
    // {
    //   path: '/system',
    //   component: Layout,
    //   meta: {
    //     title: '系统管理',
    //     icon: 'user'
    //   },
    //   children: [
    //     {
    //       path: 'user',
    //       component: () => import(/* webpackChunkName: "dashboard" */ '@/views/system/user.vue'),
    //       meta: {
    //         title: '用户管理'
    //       }
    //     },
    //     {
    //       path: 'role',
    //       component: () => import(/* webpackChunkName: "dashboard" */ '@/views/system/role.vue'),
    //       meta: {
    //         title: '角色管理'
    //       }
    //     },
    //     {
    //       path: 'menu',
    //       component: () => import(/* webpackChunkName: "dashboard" */ '@/views/system/menu.vue'),
    //       meta: {
    //         title: '菜单管理'
    //       }
    //     }
    //   ]
    // },
    {
      path: '*',
      redirect: '/404',
      meta: { hidden: true }
    }
  ]
})
